import React from 'react';
import web1Img from '../../assets/images/web1.png';
import FadeIn from '../common/FadeIn';

const TemplateDifferenceSection = ({ template }) => {
  const mockupImage = template?.img || web1Img;

  const differences = [
    {
      title: "Made for You",
      desc: "A design you love, customized around your brand and content."
    },
    {
      title: "SEO-Ready",
      desc: "A clean structure that gives your website a strong SEO foundation."
    },
    {
      title: "Simple to Launch",
      desc: "Everything you need to get your website online, without the extras."
    },
    {
      title: "Professional & Affordable",
      desc: "A polished website without the price of a fully custom build."
    }
  ];

  return (
    <section className="w-full text-[#1C1917] py-12 sm:py-16 lg:py-20 relative overflow-hidden border-t border-[#E5E0D8]">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <FadeIn className="flex flex-col items-start max-w-[570px]">
          <h2 className="font-saolDisplayItalic leading-[1.1] tracking-[0em] text-[28px] md:text-[45px] font-normal text-left w-full">
            What makes this template different
          </h2>
        </FadeIn>
      </div>

      <FadeIn>
        <div className="w-full relative my-8 lg:my-12 flex items-center">
          <div className="w-full md:w-[45%] h-[1px] bg-[#D8D2C7] order-2 md:order-1" />
          <div className="pl-3 flex items-center justify-center shrink-0 order-1 md:order-2">
            <span className="font-PromenadeItalic text-3xl md:text-4xl italic tracking-tighter select-none  leading-none">
              SSC
            </span>
          </div>
        </div>
      </FadeIn>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 items-center">

          <div className="md:col-span-6 flex justify-center lg:justify-start order-2 md:order-1">
            <FadeIn className="w-full max-w-[480px]">
              <div className="w-full max-w-[480px] bg-white rounded-sm shadow-2xl overflow-hidden border border-[#E0DAD0] flex flex-col group">
                <div className="w-full h-[380px] sm:h-[440px] md:h-[480px] lg:h-[620px] overflow-hidden relative cursor-pointer bg-white">
                  <img
                    src={mockupImage}
                    alt="Custom website template preview showing layout differences and features"
                    className="w-full h-auto object-cover object-top block transform translate-y-0 transition-transform duration-[7s] ease-in-out group-hover:-translate-y-[calc(100%-380px)] sm:group-hover:-translate-y-[calc(100%-440px)] md:group-hover:-translate-y-[calc(100%-480px)] lg:group-hover:-translate-y-[calc(100%-620px)]"
                    loading="lazy"
                    decoding="async"
                    width="480"
                    height="620"
                  />
                </div>
              </div>
            </FadeIn>
          </div>

          <div className="md:col-span-6 flex flex-col justify-center self-center my-auto space-y-8 md:space-y-10 order-1 md:order-2">
            {differences.map((item, idx) => (
              <FadeIn key={idx}>
                <div className="flex flex-col text-left">
                  <h3 className="font-saolDisplayItalic text-[18px] md:text-[22px] font-semibold leading-[1.6] tracking-[0em] mb-2">
                    {item.title}
                  </h3>
                  <p className="font-interDisplayMedium text-[14px] md:text-[16px] leading-[1.4] font-normal tracking-[0em]">
                    {item.desc}
                  </p>
                </div>
              </FadeIn>
            ))}
          </div>

        </div>
      </div>

    </section>
  );
};

export default TemplateDifferenceSection;
